import { AppCardAppStatus } from '@orcha/types/app-card-app-data/app-card-app-data.interface';

export const useAppStatus = (
  appStatus?: AppCardAppStatus,
  showCommissionableStatus?: boolean
) => {
  if (!appStatus) {
    return undefined;
  }

  if (!showCommissionableStatus) {
    return appStatus.status === 'Commissionable'
      ? undefined
      : (appStatus as AppCardAppStatus);
  }

  return appStatus;
};
